import {
    AmazonType,
    ApiType,
    AppConfiguration,
    AppType,
    AsignaturaType,
    EvaluacionTipoMap,
    HojaRespuestaType,
    PlataformaType,
    CarrerasConf
} from "@puntaje/shared/core"

export class UtemConfig implements AppConfiguration {
    generar = {
        generar: true,
        intrumentosRecomendados: true,
        pruebasPropias: true,
        buscador: true
    }

    navegacion = {
        urlHistorial: ["/evaluaciones/resultados/historial"]
    }
    app = {
        assets: {
            logoLarge: "assets/img/logos/logoLarge.png",
            logoMedium: "assets/img/logos/logoMedium.png",
            logoSmall: "assets/img/logos/logoSmall.png",
            logoLargeLight: "assets/img/logos/logoLargeLight.png",
            logoMediumLight: "assets/img/logos/logoMediumLight.png",
            logoSmallLight: "assets/img/logos/logoSmallLight.png",
            logoSquare: "assets/img/logos/logoSquare.png",
            logoInforme: "assets/img/logos/logoSmall.png",
            streamingOffline: ""
        },
        name: "profesores",
        loader: "utem",
        routeUser: null,
        routeUserInfo: null,
        paths: {
            pendingInfo: "/pending_info",
            landing: "/landing"
        }
    } as AppType

    amazon = {
        s3BucketUri: "https://s3-us-west-1.amazonaws.com/bucket-puntaje-reloaded/",
        s3BucketUriNebu: "https://s3-us-west-1.amazonaws.com/bucket-nebuloso/"
    } as AmazonType

    api = {
        checkTokenPath: "/check_token",
        authPath: "/authenticate"
    } as ApiType

    asignaturas = [
        {
            id: null,
            asignatura: "Matemática",
            icono: "matematica-4",
            clase: "matematica",
            abreviacion: "Matemática",
            asignaturaPlataforma: "Matemática",
            evaluacionTipo: ["diagnostico ensayo", "paes"],
            materialVisible: true
        },
        {
            id: null,
            asignatura: "Lenguaje",
            icono: "lenguaje-4",
            clase: "lenguaje",
            abreviacion: "Lenguaje",
            asignaturaPlataforma: "Lenguaje",
            evaluacionTipo: ["diagnostico ensayo", "paes"],
            materialVisible: true
        },
        {
            id: null,
            asignatura: "Ciencias Naturales",
            icono: "ciencias",
            clase: "ciencias",
            abreviacion: "Ciencias Naturales",
            asignaturaPlataforma: "Ciencias Naturales",
            evaluacionTipo: ["diagnostico ensayo", "paes"],
            materialVisible: true
        },
        {
            id: null,
            asignatura: "Historia y Ciencias Sociales",
            icono: "historia-4",
            clase: "historia",
            abreviacion: "Historia",
            asignaturaPlataforma: "Historia y Ciencias Sociales",
            evaluacionTipo: ["diagnostico ensayo", "paes"],
            materialVisible: true
        },
        {
            id: null,
            asignatura: "Ciencias PSU",
            icono: "ciencias-4",
            clase: "ciencias",
            abreviacion: "Ciencias",
            asignaturaPlataforma: "Ciencias",
            evaluacionTipo: ["ensayo", "diagnostico ensayo" /* , "paes" */],
            materialVisible: false
        },
        {
            id: null,
            asignatura: "Ciencias Física",
            icono: "fisica-4",
            clase: "fisica",
            abreviacion: "Física",
            asignaturaPlataforma: "Ciencias Física",
            evaluacionTipo: ["ensayo", "diagnostico ensayo" /* , "paes" */],
            materialVisible: {
                ensayo: true,
                curricular: true
            }
        },
        {
            id: null,
            asignatura: "Ciencias Química",
            icono: "quimica-5",
            clase: "quimica",
            abreviacion: "Química",
            asignaturaPlataforma: "Ciencias Química",
            evaluacionTipo: ["ensayo", "diagnostico ensayo" /* , "paes" */],
            materialVisible: {
                ensayo: true,
                curricular: true
            }
        },
        {
            id: null,
            asignatura: "Ciencias Biología",
            icono: "biologia-4",
            clase: "biologia",
            abreviacion: "Biología",
            asignaturaPlataforma: "Ciencias Biología",
            evaluacionTipo: ["ensayo", "diagnostico ensayo" /* , "paes" */],
            materialVisible: {
                ensayo: true,
                curricular: true
            }
        }
    ] as AsignaturaType[]

    plataforma = {
        name: "UTEM",
        id: null,
        pais: "chile",
        lugarTipo: "Comuna",
        lugarLabel: "Comuna",
        identificadorUsuario: ["RUT"],
        identificadorEstablecimiento: ["rbd"],
        grupoUsuarioAlias: "curso",
        info: {
            social: {
                facebook: "https://www.facebook.com/postulantesUTEM",
                twitter: "https://twitter.com/utem",
                youtube: "https://www.youtube.com/channel/UC-WNlKEfmQIA8wfMMFg9w_A",
                instagram: "https://www.instagram.com/postulantesutem/",
                linkedin: "https://www.linkedin.com/edu/school?id=11004&goback=&trk=feed-body-name"
            },
            soporte: {
                mail: "contactoutem@ogr.cl",
                telefono: "22 306 9220 (Anexo 405)"
            },
            contacto: {
                telefono: "(+56) 22 306 9220 (Anexo 419)",
                mail: "ventas@ogr.cl"
            },
            companyName: "UTEM",
            companySite: "www.puntajenacional.cl"
        },
        evaluacionDefault: "paes",
        resumenGeneral: {
            curriculum: "simce",
            generadores: [83, 15, 16, 17, 18, 84, 19, 20, 85]
        },
        tiposInstrumentoInformeUso: ["ensayo", "curricular"],
        evaluacionTipos: ["diagnostico ensayo", "paes", "diagnostico paes"],
        añoInicial: 2019,
        periodos: [
            {
                label: "",
                fechaInicial: [0, 1],
                fechaFinal: [11, 31, 23, 59, 59]
            }
        ],
        streamingDefault: "paes",
        iconSet: {
            noticiasShowcase: "megafono-o",
            establecimientosShowcase: "establecimiento-o",
            cursosShowcase: "comunidad-o"
        },
        instrumentoMensualTipo: "ensayo",
        tiposNotificacion: [
            {
                tipo: "curricular",
                label: "Pruebas"
            },
            {
                tipo: "duda",
                label: "Dudas"
            },
            {
                tipo: "ensayo",
                label: "Ensayos"
            },
            {
                tipo: "respuesta_correcta_duda",
                label: "Respuestas Correctas Dudas"
            },
            {
                tipo: "respuesta_duda",
                label: "Respuestas Dudas"
            }
        ],
        canRecoverPasswordBySMS: true,
        canTextHighlight: true,
        planClasesRoute: "/plan_clases"
    } as PlataformaType

    evaluaciones = {
        // ensayo, curricular, diagnostico ensayo
        ensayo: {
            alias: "ensayo",
            clasificaciones: {
                estadisticas: ["eje temático", "sub eje tematico"],
                groupBy: ["eje temático,sub eje tematico", "curso", "habilidad cognitiva", "mención"],
                clasificacionTiposTablaEspecificaciones: ["eje temático", "habilidad cognitiva"],
                configuration: [
                    {
                        clasificacionTipo: "eje temático",
                        name: "Eje temático",
                        htmlId: "eje",
                        hasHijos: true
                    },
                    {
                        clasificacionTipo: "curso",
                        name: "Curso",
                        htmlId: "curso",
                        hasHijos: false
                    },
                    {
                        clasificacionTipo: "habilidad cognitiva",
                        name: "Habilidad Cognitiva",
                        htmlId: "hc",
                        hasHijos: false
                    },
                    {
                        clasificacionTipo: "mención",
                        name: "Mención",
                        htmlId: "mencion",
                        hasHijos: false
                    }
                ],
                cambiarPregunta: ["eje temático", "sub eje tematico"]
            },
            clasificacionDistribucion: "ejes",
            clasificacionMaterial: {
                clasificacion: "eje temático",
                label: "eje"
            },
            clasificacionTiposEstadisticas: [
                {
                    nombre: "eje temático",
                    compuesto: false,
                    alumnos: true,
                    profesores: true,
                    informeAnual: true
                },
                {
                    nombre: "sub eje tematico",
                    compuesto: true,
                    alumnos: false,
                    profesores: true,
                    informeAnual: false
                },
                {
                    nombre: "habilidad cognitiva",
                    compuesto: false,
                    alumnos: false,
                    profesores: true,
                    informeAnual: true
                }
            ],
            cursos: [
                { clasificacion: "Primero Medio", label: "1º Medio" },
                { clasificacion: "Segundo Medio", label: "2º Medio" },
                { clasificacion: "Tercero Medio", label: "3º Medio" },
                { clasificacion: "Cuarto Medio", label: "4º Medio" }
            ],
            cursosMaterial: [],
            estrellas: [
                { min: 150, max: 266 },
                { min: 267, max: 383 },
                { min: 384, max: 500 },
                { min: 501, max: 617 },
                { min: 618, max: 734 },
                { min: 735, max: 850 }
            ],
            nivelTipoInstrumentoInformeFinal: ["1º Medio", "2º Medio", "3º Medio", "4º Medio"],
            rangoCalificacion: {
                min: 150,
                tickInterval: 50,
                max: 850
            },
            streamingChannelAlias: "Clases PSU"
        },
        curricular: {
            alias: "prueba",
            clasificaciones: {
                estadisticas: ["eje temático LGE"],
                groupBy: ["eje temático LGE,objetivo de aprendizaje", "unidad LOCE,aprendizaje esperado"],
                clasificacionTiposTablaEspecificaciones: ["objetivo de aprendizaje", "habilidad cognitiva LGE"],
                configuration: [
                    {
                        clasificacionTipo: "eje temático LGE",
                        name: "Eje de contenidos",
                        htmlId: "eje",
                        hasHijos: true
                    },
                    {
                        clasificacionTipo: "unidad LOCE",
                        name: "Unidad",
                        htmlId: "unidad",
                        hasHijos: true
                    }
                ]
            },
            clasificacionDistribucion: "ejes",
            clasificacionMaterial: {
                clasificacion: "eje temático LGE",
                label: "eje"
            },
            clasificacionTiposEstadisticas: [
                {
                    nombre: "eje temático LGE",
                    compuesto: false,
                    alumnos: true,
                    profesores: true,
                    informeAnual: true
                },
                {
                    // HEY LISTEN! acordarse que hay que manejar este caso de forma general
                    nombre: "aprendizaje esperado",
                    compuesto: false,
                    alumnos: false,
                    profesores: false,
                    informeAnual: true
                }
            ],
            cursos: [
                { clasificacion: "Primero Medio", label: "1º Medio" },
                { clasificacion: "Segundo Medio", label: "2º Medio" },
                { clasificacion: "Tercero Medio", label: "3º Medio" },
                { clasificacion: "Cuarto Medio", label: "4º Medio" }
            ],
            cursosMaterial: [
                { id: 9, clasificacion: "Primero Medio", label: "1º Medio" },
                { id: 10, clasificacion: "Segundo Medio", label: "2º Medio" },
                { id: 11, clasificacion: "Tercero Medio", label: "3º Medio" },
                { id: 12, clasificacion: "Cuarto Medio", label: "4º Medio" }
            ],
            estrellas: [
                { min: 1, max: 2 },
                { min: 2, max: 3 },
                { min: 3, max: 4 },
                { min: 4, max: 5 },
                { min: 5, max: 6 },
                { min: 6, max: 7 }
            ],
            nivelTipoInstrumentoInformeFinal: ["1º Medio", "2º Medio", "3º Medio", "4º Medio"],
            rangoCalificacion: {
                min: 0,
                tickInterval: 25,
                max: 400
            },
            streamingChannelAlias: "Clases Curriculares"
        },
        "diagnostico ensayo": {
            alias: "ensayo de diagnóstico",
            clasificaciones: {
                estadisticas: ["eje temático", "sub eje tematico"],
                groupBy: ["eje temático,sub eje tematico", "curso", "habilidad cognitiva"],
                configuration: [
                    {
                        clasificacionTipo: "eje temático",
                        name: "Eje temático",
                        htmlId: "eje",
                        hasHijos: true
                    }
                ]
            }
        },
        paes: {
            alias: "PAES",
            cantidadPreguntas: 5,
            clasificaciones: {
                estadisticas: ["Eje PAES"],
                estadisticasEvolutivas: ["Eje PAES"],
                desempenoEvaluacion: "Eje PAES",
                groupBy: ["Eje PAES,Unidad Temática PAES"],
                clasificacionTiposTablaEspecificaciones: ["Eje PAES", "Unidad Temática PAES"],
                methods: "clasificaciones",
                referencesTo: {
                    "Unidad Temática PAES": "Eje PAES"
                },
                configuration: [
                    {
                        name: "Eje PAES",
                        htmlId: "Eje_PAES",
                        hasHijos: true,
                        clasificacionTipo: "Eje PAES"
                    }
                ],
                cambiarPregunta: ["nivel 1 prueba de transición"]
            },
            clasificacionDistribucion: "ejes",
            clasificacionMaterial: {
                clasificacion: "Eje PAES",
                label: "eje"
            },
            clasificacionTiposEstadisticas: [
                {
                    nombre: "Eje PAES",
                    alumnos: true,
                    compuesto: true,
                    profesores: true,
                    informeAnual: true
                },
                {
                    nombre: "Unidad Temática PAES",
                    alumnos: true,
                    compuesto: true,
                    profesores: true,
                    informeAnual: false
                },
                {
                    nombre: "Habilidad PAES",
                    alumnos: false,
                    compuesto: true,
                    profesores: true,
                    informeAnual: true
                }
            ],
            cursoTipo: "curso PSU",
            cursos: [
                {
                    label: "7º Medio",
                    clasificacion: "Séptimo Básico"
                },
                {
                    label: "8º Medio",
                    clasificacion: "Octavo Básico"
                },
                {
                    label: "1º Medio",
                    clasificacion: "Primero Medio"
                },
                {
                    label: "2º Medio",
                    clasificacion: "Segundo Medio"
                },
                {
                    label: "3º Medio",
                    clasificacion: "Tercero Medio"
                },
                {
                    label: "4º Medio",
                    clasificacion: "Cuarto Medio"
                }
            ],
            cursosMaterial: [],
            estrellas: [
                {
                    max: 266,
                    min: 150
                },
                {
                    max: 383,
                    min: 267
                },
                {
                    max: 500,
                    min: 384
                },
                {
                    max: 617,
                    min: 501
                },
                {
                    max: 734,
                    min: 618
                },
                {
                    max: 850,
                    min: 735
                }
            ],
            nivelTipoInstrumentoInformeFinal: ["1º Medio", "2º Medio", "3º Medio", "4º Medio"],
            rangoCalificacion: {
                min: 150,
                tickInterval: 50,
                max: 850
            },
            streamingChannelAlias: "Clases Prueba de transición",
            planPersonalClasificacionMateriales: []
        }
    } as EvaluacionTipoMap

    instrumentosPredefinidos = {
        zonas: ["Columna 1", "Columna 2", "Columna 3"]
    }

    hojaRespuesta = {
        sectores: [
            [1, 2],
            [2, 3],
            [3, 4],
            [5, 2],
            [2, 7],
            [7, 4],
            [5, 6],
            [6, 7],
            [7, 8]
        ],
        alternativas: 5
    } as HojaRespuestaType

    mensajesLogin = {
        idPlaceholder: "Email o RUT(sin puntos, con digito verificador)",
        invalidLoginId: "Debes incluir un correo electrónico o RUT válido.",
        invalidLoginMessage1:
            "<strong>La combinación de correo electrónico/contraseña o RUT/contraseña es incorrecta.</strong> Las contraseñas de ",
        invalidLoginMessage2:
            ' distinguen entre mayúsculas y minúsculas. Por favor, comprueba la tecla "Bloq Mayús". También puedes probar a borrar el caché y las cookies de tu navegador.',
        invalidLoginInactiveEstablishments: "",
        invalidLoginInactiveEstablishmentsRedirectText: ""
    }

    carreras = {
        evaluacionTipo: ["paes"],
        ponderables: [
            {
                orden: 1,
                ponderable: "Matemática",
                asignaturaAsociada: "Matemática",
                tipo: "calificable"
            },
            {
                orden: 2,
                ponderable: "Lenguaje y Comunicación",
                asignaturaAsociada: "Lenguaje",
                tipo: "calificable"
            },
            {
                orden: 3,
                ponderable: "Historia y Ciencias Sociales",
                asignaturaAsociada: "Historia y Ciencias Sociales",
                tipo: "calificable",
                categoria: "ciencias-historia"
            },
            {
                orden: 4,
                ponderable: "Ciencias",
                asignaturaAsociada: "Ciencias PSU",
                tipo: "calificable",
                categoria: "ciencias-historia"
            },
            {
                orden: 5,
                ponderable: "NEM",
                clase: "nem",
                tipo: "ingresable",
                field: "nem",
                minValue: 150,
                maxValue: 850
            },
            {
                orden: 6,
                ponderable: "Ranking",
                clase: "ranking",
                tipo: "ingresable",
                field: "ranking",
                minValue: 150,
                maxValue: 850
            }
        ]
    } as CarrerasConf

    aditionalClass: false
}
